<template>
  <span>
    <a-button icon="schedule" @click="visibleModal = true">{{ label }}</a-button>

    <modal-fullscreen
      title="Reoccurring Schedule"
      :visible="visibleModal"
      :destroy-on-close="true"
      width="1100px"
      @cancel="visibleModal = false"
    >
      <div class="profile-schedule">
        <a-spin :spinning="loading">
          <div v-if="schedule" class="profile-schedule__content">
            <schedule-section
              title="On Call Availability"
              :value="schedule.availability"
              @input="updateSection('availability', $event)"
            />
            <schedule-section
              title="Reoccurring Schedule"
              :value="schedule.regular_schedule"
              @input="updateSection('regular_schedule', $event)"
            />
          </div>
        </a-spin>
      </div>

      <template slot="footer">
        <div class="flex justify-content-between">
          <a-button @click="visibleModal = false">Close</a-button>
          <a-button type="primary" icon="save" :loading="saving" :disabled="loading || !schedule" @click="saveSchedule">
            Save
          </a-button>
        </div>
      </template>
    </modal-fullscreen>
  </span>
</template>

<script>
import { Button, notification, Spin } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import ScheduleSection from './schedule-section.vue'
import { normalizeSchedule, normalizeSection, sanitizeSection } from './schedule-utils'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')

export default {
  name: 'ProfileScheduleAction',
  components: {
    'a-button': Button,
    'a-spin': Spin,
    'schedule-section': ScheduleSection
  },
  props: {
    label: {
      type: String,
      default: 'Rec. Schedule'
    }
  },
  data() {
    return {
      visibleModal: false,

      loading: false,
      saving: false,
      schedule: null
    }
  }, computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  watch: {
    'associate.id': {
      handler(newVal) {
        if (newVal) {
          this.fetchSchedule()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...profileActions(['getAssociateSchedule', 'postAssociateSchedule']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    updateSection(key, section) {
      this.schedule = {
        ...this.schedule,
        [key]: normalizeSection(section)
      }
    },

    async fetchSchedule() {
      if (!this.associate?.id) {
        return
      }

      this.loading = true

      try {
        const schedule = await this.getAssociateSchedule({
          associate_id: this.associate.id
        })

        this.schedule = normalizeSchedule(schedule)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    },

    async saveSchedule() {
      if (!this.associate?.id || !this.schedule) {
        return
      }

      const schedule = {
        availability: sanitizeSection(this.schedule.availability),
        regular_schedule: sanitizeSection(this.schedule.regular_schedule)
      }

      this.saving = true

      try {
        const savedSchedule = await this.postAssociateSchedule({
          associate_id: this.associate.id,
          schedule
        })

        this.schedule = normalizeSchedule(savedSchedule ?? schedule)
        this.showNotification('success', 'Success', 'Schedule has been saved.')
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style scoped>

.profile-schedule {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 640px;
  overflow: auto;
}

.profile-schedule__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
